import {Component, Input} from '@angular/core';
import {TimeService} from "../../../../core/services/time.service";
import {IconService} from "../../../../core/services/icon.service";

@Component({
  selector: 'app-evidence-list-item',
  templateUrl: './evidence-list-item.component.html',
  styleUrls: ['./evidence-list-item.component.scss', '../../../../../assets/audit/audit.scss']
})
export class EvidenceListItemComponent {
    @Input() evidence: any = null;
    @Input() receiver: any = null;

    constructor(
        public timeService: TimeService,
        public iconService: IconService
    ) {

    }
}
